{
  "bliksy": {
    "inputPlaceholder": "Posez votre question",
    "disclaimer": "BLIKSY est assisté par l'IA et peut produire des erreurs. Veuillez vérifier les réponses.",
    "resizeHandle": "Redimensionner le panneau de discussion"
  },
  "voiceInput": {
    "startRecording": "Démarrer l'enregistrement vocal",
    "stopRecording": "Arrêter l'enregistrement",
    "cancelRecording": "Annuler l'enregistrement",
    "transcribing": "Transcription en cours...",
    "microphoneDenied": "L'accès au microphone a été refusé.",
    "recordingFailed": "Échec de l'enregistrement. Veuillez réessayer.",
    "transcriptionFailed": "Échec de la transcription audio. Veuillez réessayer."
  },
  "chat": {
    "sendMessage": "Envoyer le message",
    "transcript": "Transcription du chat",
    "messageFailed": "Ce message ne peut pas être affiché.",
    "retry": "Réessayer",
    "sourcesLabel": "Sources",
    "chart": {
      "loading": "Préparation du graphique…",
      "failed": "Le graphique n'a pas pu être créé.",
      "hoursSuffix": "{{value}} h",
      "percentSuffix": "{{value}} %",
      "coverageOmitted": "{{omitted}} entrées sur {{requested}} ne sont pas affichées.",
      "coverageTruncated": "Seules les {{rendered}} entrées les plus importantes sont affichées.",
      "pointLabels": {
        "restricted": "Aucun accès",
        "unknown": "Inconnu",
        "unassigned": "Non attribué"
      }
    },
    "diagram": {
      "label": "Diagramme",
      "loading": "Préparation du diagramme…",
      "failed": "Le diagramme n'a pas pu être affiché.",
      "expand": "Agrandir le diagramme",
      "zoomIn": "Agrandir",
      "zoomOut": "Réduire",
      "resetZoom": "Réinitialiser la vue"
    },
    "document": {
      "preparing": "Préparation du fichier…",
      "failed": "Le fichier n'a pas pu être créé.",
      "download": "Télécharger le fichier",
      "rows": "{{rows}} lignes · disponible jusqu'au {{expiry}}",
      "partialRows": "Les {{rows}} premières lignes · disponible jusqu'au {{expiry}}",
      "rowsOnly": "{{rows}} lignes",
      "partialRowsOnly": "Les {{rows}} premières lignes",
      "omitted": "{{omitted}} lignes ne sont pas incluses.",
      "expired": "Ce fichier n'est plus disponible.",
      "downloadFailed": "Le téléchargement n'a pas pu être lancé."
    },
    "entityView": {
      "loading": "Préparation de la vue…",
      "unavailable": "Cette vue n'est plus disponible.",
      "noDecisionRules": "Cette étape ne comporte plus de table de décision.",
      "loadFailed": "La vue n'a pas pu être chargée.",
      "current": "État actuel",
      "updatedAt": "Mis à jour le {{date}}",
      "untitledStep": "Étape sans nom",
      "openProcess": "Ouvrir le processus",
      "openFullscreen": "Ouvrir en plein écran",
      "exitFullscreen": "Quitter le plein écran"
    },
    "entityCard": {
      "loading": "Chargement des détails…",
      "unavailable": "Cet enregistrement n'est plus disponible.",
      "loadFailed": "Les détails n'ont pas pu être chargés."
    },
    "attachment": {
      "fallbackName": "Fichier",
      "label": "Fichier joint",
      "attach": "Joindre un fichier",
      "remove": "Supprimer la pièce jointe",
      "dropHint": "Déposez ici un PDF ou une image",
      "uploading": "Téléversement en cours...",
      "tooMany": "Au maximum {{max}} fichiers par message",
      "unsupported": "Fichiers PDF, PNG ou JPEG uniquement",
      "tooLarge": "Au maximum {{maxMegabytes}} Mo",
      "uploadFailed": "Échec du téléversement"
    },
    "feedback": {
      "thumbsUp": "Utile",
      "thumbsDown": "Pas utile",
      "commentTitle": "Qu'est-ce qui n'allait pas dans cette réponse ?",
      "commentPlaceholder": "Dites-nous ce qui n'a pas fonctionné",
      "commentSend": "Envoyer",
      "error": "Votre avis n'a pas pu être enregistré."
    }
  },
  "thinkingPhases": {
    "stepSummary": {
      "start1": "Analyse de la tâche…",
      "middle1": "Création du résumé…",
      "end1": "Affinage du texte…"
    },
    "chat": {
      "start1": "Lecture de votre question…",
      "start2": "Compréhension de votre question…",
      "middle1": "Recherche d'informations pertinentes…",
      "middle2": "Vérification des sources…",
      "middle3": "Examen du modèle de processus…",
      "end1": "Composition de la réponse…",
      "end2": "Affinage de la formulation…"
    }
  }
}
